import { toggle } from "./utils/ui-helpers.js";

export function updatePaymentPlanSelectors(isUsingDeposit, costsObj) {
    const { deposit, balance, balanceDueDate, balanceOnArrival, balanceType } = costsObj;
    const paymentSelectors = document.querySelectorAll('.atb-payment-plan-selector');
    const isFullPaymentOnly = !isUsingDeposit;
    
    // A blank due date is intentional for payment on arrival/departure.
    // Never pass null to Date: JavaScript would display the Unix epoch.
    const dueDate = !balanceOnArrival && typeof balanceDueDate === 'string' && balanceDueDate.trim()
        ? new Date(balanceDueDate)
        : null;
    const hasDueDate = dueDate !== null && !Number.isNaN(dueDate.getTime());
    const stayPaymentTiming = balanceOnArrival
        ? (balanceType === 2 ? 'on departure' : 'on arrival')
        : '';
    const longBalanceTiming = stayPaymentTiming || (hasDueDate ? `on ${balanceDueDate}` : '');
    const shortBalanceTiming = stayPaymentTiming || (hasDueDate ? `by ${dueDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
    })}` : '');

    const payFullSelectors = document.querySelectorAll('.atb-payment-plan.pay-full');
    if (isUsingDeposit)
        payFullSelectors.forEach(ps => ps.classList.remove('rounded-top-2', 'border-top'));
    else
        payFullSelectors.forEach(ps => ps.classList.add('rounded-top-2', 'border-top'));

    paymentSelectors.forEach(paymentSelector => {
        const usingReducedWording = paymentSelector.classList.contains('use-reduced-wording');
        const isSummarySelector = paymentSelector.id === 'atb-payment-plan-selector-summary';
        const summarySection = paymentSelector.closest('.atb-summary-payment-selector-section');

        paymentSelector.classList.toggle('is-full-payment-only', isFullPaymentOnly);

        if (summarySection)
            summarySection.hidden = isFullPaymentOnly;

        // Toggle deposit plan container
        const depositPlan = paymentSelector.querySelector('.atb-payment-plan.pay-deposit');
        if (depositPlan) {
            toggle(depositPlan, isUsingDeposit);
        }

        // Deposit cost
        paymentSelector.querySelectorAll('.atb-pay-deposit-cost').forEach(el => {
            el.innerHTML = deposit;
            toggle(el, isUsingDeposit, 'flex');
        });

        // Deposit detail text
        paymentSelector.querySelectorAll('.atb-payment-type-deposit-detail').forEach(el => toggle(el, isUsingDeposit));

        // There is no choice to expose when full payment is the only option.
        paymentSelector.querySelectorAll('input[type="radio"]').forEach(input => {
            toggle(input, isUsingDeposit);
            input.disabled = isFullPaymentOnly;
        });

        // A sole full-payment option is information, not a control. The summary
        // version is hidden above; the payment-stage version remains as static text.
        const fullPaymentPlan = paymentSelector.querySelector('.atb-payment-plan.pay-full');
        if (fullPaymentPlan) {
            fullPaymentPlan.classList.toggle('selected', !isFullPaymentOnly && fullPaymentPlan.querySelector('input:checked') !== null);
            fullPaymentPlan.toggleAttribute('inert', isFullPaymentOnly && !isSummarySelector);
        }

        // Balance cost
        paymentSelector.querySelectorAll('.atb-summary-balance-cost').forEach(el => {
            el.innerHTML = balance;
        });

        // Balance payable date
        paymentSelector.querySelectorAll('.atb-balance-payable-date').forEach(el => {
            el.textContent = usingReducedWording ? shortBalanceTiming : longBalanceTiming;
        });
    });
}


/**
 * Updates the selected payment plan by adding the 'selected' class to the correct element and checking the corresponding radio input
 *
 * @param {string} paymentType - The payment type to select (e.g., "full" or "deposit").
 */
export function updatePaymentSelectedClass(paymentType) {
    document.querySelectorAll('.atb-payment-plan').forEach(element => {
        const radioInput = element.querySelector(`input[data-payment-type='${paymentType}']`);
        element.classList.toggle('selected', radioInput !== null);
                
        if (radioInput) radioInput.checked = true;
    });
}
